<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,6.11C16,6.11,10.47,5.27,10.47,5.27C10.47,5.27,8,0,8,0C8,0,5.53,5.27,5.53,5.27C5.53,5.27,0,6.11,0,6.11C0,6.11,4,10.21,4,10.21C4,10.21,3.06,16,3.06,16C3.06,16,8,13.27,8,13.27C8,13.27,12.94,16,12.94,16C12.94,16,12,10.21,12,10.21C12,10.21,16,6.11,16,6.11C16,6.11,16,6.11,16,6.11C16,6.11,16,6.11,16,6.11ZM4.91,13.2C4.91,13.2,5.5,9.58,5.5,9.58C5.5,9.58,3,7.02,3,7.02C3,7.02,6.45,6.49,6.45,6.49C6.45,6.49,8,3.2,8,3.2C8,3.2,9.55,6.49,9.55,6.49C9.55,6.49,13,7.02,13,7.02C13,7.02,10.5,9.58,10.5,9.58C10.5,9.58,11.09,13.2,11.09,13.2C11.09,13.2,8,11.49,8,11.49C8,11.49,4.91,13.2,4.91,13.2C4.91,13.2,4.91,13.2,4.91,13.2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'StarEmpty',
} as DefineComponent
</script>
